import { render, staticRenderFns } from "./ChatDialog.vue?vue&type=template&id=14e74472&scoped=true"
import script from "./ChatDialog.vue?vue&type=script&lang=js"
export * from "./ChatDialog.vue?vue&type=script&lang=js"
import style0 from "./ChatDialog.vue?vue&type=style&index=0&id=14e74472&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14e74472",
  null
  
)

export default component.exports